import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

/**
 * Локальный error boundary для некритичных блоков: при ошибке рендера скрывает только сам блок
 * (дефолтная заглушка @cian/error-log-component — пустой <span/>) и не даёт ошибке дойти
 * до корневого boundary, который заменил бы страницу снимком SSR-разметки.
 *
 * Оборачивать можно только то, чего нет в контенте для индексации: модалки, тосты, слоты
 * микрофронтов. Обёртка над индексируемым блоком сделает хуже — блок исчезнет вместо того,
 * чтобы страница целиком откатилась к серверной разметке.
 */
export const BlockErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { logger } = useApplicationContext();

  return <ErrorLogComponent logger={logger}>{children}</ErrorLogComponent>;
};
